var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"color-picker",class:{ active: _vm.active },style:({ background: _vm.color }),attrs:{"disabled":_vm.disabled},on:{"click":() => { if (!_vm.disabled) _vm.$emit('input', _vm.color) }}})
}
var staticRenderFns = []

export { render, staticRenderFns }